<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    title="热门搜索关键词"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 关键词 -->
      <a-form-item
        label="关键词"
        :rules="[{ required: true }]"
      >
        <!-- 单条数据 -->
        <a-form-item
          class="play-item"
          v-for="(item, index) in formState.keywords"
          :key="index"
          :rules="[{ required: true, message: '请输入' }]"
          :name="['keywords', index, 'name']"
        >
          <a-input
            style="width: 300px"
            placeholder="请输入"
            v-model:value="item.name"
          >
          </a-input>
          <!-- 第一组不允许上移 -->
          <a-button
            type="link"
            :disabled="index === 0"
            @click="move(index, 'up')"
          >
            上移
          </a-button>
          <!-- 最后一组不允许下移 -->
          <a-button
            type="link"
            :disabled="index === formState.keywords.length - 1"
            @click="move(index, 'down')"
          >
            下移
          </a-button>
          <!-- 唯一一组不允许删除 -->
          <a-button
            type="link"
            :disabled="formState.keywords.length <= 3"
            @click="deletePlay(index)"
          >
            删除
          </a-button>
        </a-form-item>
      </a-form-item>
      <div style="margin: -20px 0 0 112px;">
        <a @click="addPlay">新增关键词</a>
      </div>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import { frontdeskSave } from '@/api/request'

// emit
const emit = defineEmits(['success'])
// Form实例
const RefForm = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// id
let id = ref(null)
// 详情
let detail = ref({})
// 短剧列表
let dramas = ref([])
// 表单
let formState = reactive({
  // 关键词
  keywords: [
    {
      name: undefined,
    },
    {
      name: undefined,
    },
    {
      name: undefined,
    }
  ]
})

// 打开抽屉
function showDrawer (params) {
  // 展开
  detail.value = params
  visible.value = true
  // 赋值
  nextTick(() => {
    if (params) {
      id.value = params.id
      if (params.content && params.content.length > 0) {
        const keywords = []
        for (const index in params.content) {
          const item = params.content[index]
          keywords.push({ name: item })
        }
        formState.keywords = keywords
      }
    }
  })
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    // 重置
    RefForm.value.resetFields()
    id.value = undefined
    visible.value = false
  }
}

// 删除短剧
function deletePlay (index) {
  formState.keywords.splice(index, 1)
}

// 移动短剧
function move (index, type) {
  // 保存当前项
  const temp = formState.keywords[index]
  if (type === 'up') {
    // 处理上移
    formState.keywords[index] = formState.keywords[index - 1]
    formState.keywords[index - 1] = temp
  } else {
    // 处理下移
    formState.keywords[index] = formState.keywords[index + 1]
    formState.keywords[index + 1] = temp
  }
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    const paramInfos = {
      id: id.value,
      content: formState.keywords.map(item => item.name),
    }
    frontdeskSave(paramInfos).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('更新成功')
        onClose()
        // 更新父组件
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

// 新增短剧位
function addPlay () {
  formState.keywords.push({
    name: undefined,
  })
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.a-link {
  margin-left: 8px;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  position: relative;
  width: 118px;
  height: 148px;
  border-radius: 4px;
  overflow: hidden;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
.upload-item-select {
  position: absolute;
  right: 8px;
  bottom: 8px;
}
.upload-item-delete {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 18px;
  color: #8D8D8D;
  cursor: pointer;
  opacity: 0;
}
.form-upload-item:hover .upload-item-delete {
  opacity: 1;
}
.date-range {
  color: #8D8D8D;
  padding-left: 100px;
  margin-top: -15px;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  width: 118px;
}
.image-view.upload-image {
  height: 148px;
}
.image-view.upload-image-horizontal {
  width: 208px;
  height: 124px;
}
.desc-textarea {
  word-wrap: break-word;
  white-space: normal;
  word-break: break-all;
}

.drama-menu {
  display: flex;
  padding: 6px 0 0 6px;
  flex-wrap: wrap;
  .ant-form-item {
    margin-right: 6px;
  }
}


.play-item {
  margin-bottom: 16px;
  .ant-btn-link {
    padding: 0;
    margin-left: 8px;
  } 
}
</style>